import {CdkDragDrop, CdkDragStart, transferArrayItem} from '@angular/cdk/drag-drop';
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    SimpleChange,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {catchError, EMPTY, Subscription, switchMap, tap} from 'rxjs';
import {TaskModel} from '../../models/task.model';
import {CrmService} from '../../services/api/crm.service';
import {HelpersService} from '../../services/helpers.service';
import {ModalService} from '../../services/modal/modal.service';
import {AlertService} from '../../services/notify/alert.service';
import {TaskServiceService} from '../../services/task-service.service';
import {TaskBoardModel} from '../../models/tasktable.model';

import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {MemberService} from '../../services/member.service';
import {MemberModel} from '../../models/user.model';
import {PaginationModel} from '../../models/file-table.model';
import {TranslateService} from '@ngx-translate/core';
import {AppPinDialogComponentMT} from '../material/pin-dialog/app-pin-dialog.component';

interface StatusWithTask {
    data: {
        backgrCol: string,
        svg: {
            class: string;
            svg1: string;
            svg2: string;
        }
    };
    id: number;
    is_archive: boolean;
    is_closing_status: boolean;
    is_initial: boolean;
    is_hidden: boolean;
    is_successful: boolean;
    to_archive: boolean;
    is_universal: boolean;
    is_finish: boolean;
    label: string;

    tasks?: TaskModel[];
    canDrop?: boolean;
}

@Component({
    selector: 'app-task-column',
    templateUrl: './task-column.component.html',
    styleUrls: ['./task-column.component.scss'],
})
export class TaskColumnComponent implements OnInit, OnChanges {
    @Input() public alias: string;
    @Input() public emitReload: EventEmitter<TaskModel> = new EventEmitter<TaskModel>();
    @Input() public emitSaveSettings: EventEmitter<any> = new EventEmitter<any>();
    @Input() range: any;

    @ViewChild('taskView') public viewTask: TemplateRef<any>;

    showMoreTaskTypes = false;
    public tasks: TaskModel[] = [];
    taskId: string;
    statusesWithTask: StatusWithTask[] = [];
    sort: SimpleChange;
    isLoading = false;
    taskTypes: any;
    board: TaskBoardModel;
    loading = true;
    columnSize: number;
    currentMember: MemberModel;
    pin: string = null;
    changingStatus: CdkDragDrop<any>;
    sortParamsGroup: {
        key: string,
        type: string
    };
    @ViewChild('filterContainer') private filterContainer: ElementRef;
    @ViewChild('filterButtonShowContainer') private filterButtonShowContainer: ElementRef;

    private subscriptions: Subscription = new Subscription();
    private pinDialogRef: MatDialogRef<AppPinDialogComponentMT>;

    constructor(
        private crmService: CrmService,
        private router: Router,
        private route: ActivatedRoute,
        public alert: AlertService,
        public taskService: TaskServiceService,
        public modalService: ModalService,
        public helper: HelpersService,
        public memberService: MemberService,
        protected translate: TranslateService,
        private dialog: MatDialog,
        private changeDetectionRef: ChangeDetectorRef,
    ) {
    }

    ngOnInit(): void {
        if (!this.alias) {
            this.route.params.subscribe(res => {
                this.alias = res.alias;
                if (window.location.hash) {
                    return this.router.navigate([
                        'account',
                        'tasks',
                        'all',
                        this.alias,
                        window.location.hash.substring(1),
                    ]);
                } else {
                    void this.loadTasks();
                }
            });
        } else {
            void this.loadTasks(true);
        }

        this.emitReload.subscribe(reload => {
            if (reload) {
                void this.loadTasks();
                this.taskId = reload.task_alias;
                this.modalService.openTemplateModal(this.viewTask, 'xl');
                window.location.hash = this.taskId.toString();
            }
        });

        this.emitSaveSettings.subscribe(reload => {
            this.columnSize = JSON.parse(localStorage.getItem('board_col-size'))[this.alias];
            if (reload !== false) {
                void this.loadTasks(true);
            }
        });

        this.memberService.getCurrentMember().then(res => {
            this.currentMember = res;
        });
    }

    @HostListener('document:click', ['$event'])
    afterClick(event: MouseEvent): void {
        const clickTarget = event.target;

        if (this.filterButtonShowContainer && this.filterButtonShowContainer.nativeElement.contains(event.target)) {
            this.showMoreTaskTypes = true;
        }

        if (this.filterContainer && !this.filterContainer.nativeElement.contains(clickTarget)) {
            this.showMoreTaskTypes = false;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.sort = changes.range;
        if (changes.range.currentValue && (!changes.range.previousValue || !changes.range.previousValue[1])) {
            for (const element of this.statusesWithTask) {
                if (changes.range.currentValue[1]) {
                    element.tasks = element.tasks.filter(
                        x => this.helper.dateFromFormat(x.deadline_at) <= changes.range.currentValue[1] || !x.deadline_at,
                    );
                } else {
                    element.tasks = element.tasks.filter(
                        x => this.helper.dateFromFormat(x.deadline_at) >= changes.range.currentValue[0] || !x.deadline_at,
                    );
                }
            }
        } else {
            void this.loadTasks();
        }
    }

    async loadTasks(update = false): Promise<void> {
        let size: number;
        if (localStorage.getItem('board_col-size')) {
            size = JSON.parse(localStorage.getItem('board_col-size'))[this.alias];
        }
        this.columnSize = size ? size : 280;
        if (!this.alias) {
            return;
        }

        let allSortParams = JSON.parse(localStorage.getItem('tasksSortParamsGroup'));

        if (allSortParams) {
            if (allSortParams[this.alias]) {
                this.sortParamsGroup = allSortParams[this.alias];
            } else {
                this.sortParamsGroup = {
                    key: 'task_alias',
                    type: 'asc',
                };
            }
        } else {
            allSortParams = {};
            allSortParams[this.alias] = this.sortParamsGroup = {
                key: 'task_alias',
                type: 'asc',
            };

            localStorage.setItem('tasksSortParamsGroup', JSON.stringify(allSortParams));
        }

        this.taskService.getBoard(this.alias, update).then(res => {
            this.board = structuredClone(res.board);
            this.board.task_types.unshift({
                icon: '',
                id: 0,
                name: '',
                key: 'MY_TASKS',
                isHidden: true,
            });
            if (localStorage.getItem('board_types_filter') &&
                JSON.parse(localStorage.getItem('board_types_filter'))[this.board.alias]) {
                for (const type of this.board.task_types) {
                    const localType = JSON.parse(localStorage.getItem('board_types_filter'))[this.board.alias][type.id];
                    if (localType) {
                        type.isHidden = localType;
                    } else {
                        type.isHidden = false;
                    }
                }
                this.taskTypes = this.board.task_types;
            } else {
                if (!this.taskTypes || !this.taskTypes.length) {
                    this.taskTypes = this.board.task_types;
                    for (const taskType of this.taskTypes) {
                        taskType.isHidden = taskType.isHidden ? taskType.isHidden : false;
                    }
                }
            }
            this.sortTasks(res.board);
        }).catch(() => {
            this.router.navigate(['account', 'tasks', 'all']);
        });
    }

    filterByTaskTypeInBoard(type): void {
        type.isHidden = !type.isHidden;
        if (type.isHidden && type.id !== 0) {
            for (const status of this.statusesWithTask) {
                status.tasks = status.tasks.filter(x => x.task_type.id !== type.id);
            }
        } else {
            const pagination = new PaginationModel();
            pagination.sort_by = 'title';
            this.taskService.getTasks(this.board, pagination).then(res => {
                this.tasks = res.tasks;
                this.sortTasksByTypes();
            });
        }

        const typeIds = {};
        for (const taskType of this.taskTypes) {
            typeIds[taskType.id] = taskType.isHidden;
        }

        let types = {};
        if (localStorage.getItem('board_types_filter')) {
            types = JSON.parse(localStorage.getItem('board_types_filter'));
            types[this.board.alias] = typeIds;
            localStorage.setItem('board_types_filter', JSON.stringify(types));
        } else {
            types[this.board.alias] = typeIds;
            localStorage.setItem('board_types_filter', JSON.stringify(types));
        }

        this.changeSortParams(this.sortParamsGroup.key, this.sortParamsGroup.type);
    }

    sortTasksByTypes(): void {
        for (const taskType of this.taskTypes) {
            this.tasks = this.tasks.filter(x => x.task_type.id !== taskType.id || !taskType.isHidden);
        }
        if (!this.taskTypes[0].isHidden) {
            this.tasks = this.tasks.filter(x => x.user_roles.length || x.author_guid === this.currentMember.guid);
        }
        this.statusesWithTask = [];
        for (const element of this.board.status_node_settings_of_member) {
            if (!element.is_hidden) {
                const column: StatusWithTask = Object.assign({}, element.status_node);
                column.tasks = this.tasks.filter(x => x.status_current.id === element.status_node.id);
                this.statusesWithTask.push(column);
            }
        }
    }

    changeSortParams(
        newKey: string,
        newType: string,
    ): void {
        this.sortParamsGroup = {
            key: newKey,
            type: newType,
        };

        const allSortParams = JSON.parse(localStorage.getItem('tasksSortParamsGroup'));
        allSortParams[this.alias] = this.sortParamsGroup;
        localStorage.setItem('tasksSortParamsGroup', JSON.stringify(allSortParams));

        this.sortTasks(this.board, true);
    }

    sortTasks(selectedBoard, isSearchRequest = false, searchingText = ''): void {
        if (this.statusesWithTask.length) {
            this.isLoading = true;
        } else {
            this.loading = true;
        }

        const pagination = new PaginationModel();
        pagination.sort_by = 'title';

        this.taskService.getTasks(selectedBoard, pagination, !isSearchRequest).then(res => {
            this.tasks = res.tasks;
            if (this.taskTypes && this.taskTypes.length) {
                this.sortTasksByTypes();
            }
            this.tasks = this.taskService.sortTasksBySearch(this.tasks, searchingText);

            this.statusesWithTask = [];

            for (const element of selectedBoard.status_node_settings_of_member) {
                const tasks = this.tasks.filter(x => x.status_current.id === element.status_node.id).sort((n1, n2) => {

                    let arg1 = n1[this.sortParamsGroup.key];
                    let arg2 = n2[this.sortParamsGroup.key];

                    if (this.sortParamsGroup.key === 'task_alias') {
                        arg1 = Number(n1[this.sortParamsGroup.key].split('-')[1]);
                        arg2 = Number(n2[this.sortParamsGroup.key].split('-')[1]);
                    }

                    if (this.sortParamsGroup.type === 'asc') {
                        return arg1 > arg2 ? 1 : -1;
                    } else {
                        return arg1 < arg2 ? 1 : -1;
                    }
                });
                if (!element.is_hidden) {
                    const column = Object.assign({}, element.status_node);
                    column.tasks = tasks;
                    this.statusesWithTask.push(column);
                }
            }
            this.isLoading = false;
            this.loading = false;
        });
    }

    goToTask(task: TaskModel): void {
        this.taskId = task.task_alias;
        window.location.hash = this.taskId.toString();
        this.modalService.openTemplateModal(this.viewTask, 'xl');
    }

    closeModal(refresh: boolean, modal?: NgbModalRef): void {
        if (refresh) {
            void this.loadTasks();
        } else {
            if (this.modalService.modalCount >= 1) {
                return;
            }
        }

        window.location.hash = '';
        if (modal) {
            modal.close();
        }
    }

    drop(event: CdkDragDrop<any>): NgbModalRef | any {
        if (event.previousContainer !== event.container) {
            if (!event.container.data.canDrop) {
                return this.alert.setAlert(this.translate.instant('ALERTS.CHANGE_STATUS'), 'blue');
            }

            if (event.container.data.is_successful && event.item.data.contract_guid) {
                this.changingStatus = event;
                return this.openPinModal();
            }
            this.updateDropStatus(event);
        }
        for (const element of this.statusesWithTask) {
            element.canDrop = false;
        }
    }

    openPinModal() {
        const isSign = true;
        this.pinDialogRef = this.dialog.open(AppPinDialogComponentMT);
        this.pinDialogRef.componentInstance.isSign = isSign;
        this.pinDialogRef.componentInstance.header = this.translate.instant('MODALS.HEADERS.CONFIRM_TASK_STATUS');

        this.subscriptions.add(
            this.pinDialogRef.afterClosed()
                .pipe(
                    tap(() => {
                        this.changeDetectionRef.detectChanges();
                    }),
                    switchMap((pin: { pin: string }): null => {
                        if (pin.pin) {
                            this.pin = pin.pin;
                            this.updateDropStatus(this.changingStatus);
                            return;
                        }
                        return;
                    }), catchError(() => {
                        this.changeDetectionRef.detectChanges();
                        return EMPTY;
                    })
                ).subscribe());
    }

    updateDropStatus(event: CdkDragDrop<any>): void {
        this.crmService.updateTaskStatus(event.item.data.task_alias, event.container.data.id, this.pin).subscribe({
            next: res => {
                transferArrayItem(
                    event.previousContainer.data,
                    event.container.data,
                    event.previousIndex,
                    event.currentIndex,
                );
                this.alert.setAlert(res.message, 'green');
                transferArrayItem(
                    event.previousContainer.data.tasks,
                    event.container.data.tasks,
                    event.previousIndex,
                    event.currentIndex,
                );
                this.pin = null;
                this.changingStatus = undefined;
                void this.loadTasks();
            }, error: error => {
                this.pin = null;
                this.alert.setAlert(error.message, 'blue');
            },
        });
    }

    update(task: CdkDragStart): void {
        const taskData: TaskModel = task.source.data;
        const dependencies = [];
        for (const element of this.board.status_edges) {
            if (element.target.toString() === taskData.status_current.id.toString() ||
                element.source.toString() === taskData.status_current.id.toString()) {
                dependencies.push(element);
            }
        }

        let availableStatuses = [];
        if (dependencies) {
            for (const dep of dependencies) {
                if (dep.target === taskData.status_current.id) {
                    availableStatuses.push(this.board.status_node_settings_of_member.filter(x => x.status_node.id === dep.source)[0]);
                } else {
                    availableStatuses.push(this.board.status_node_settings_of_member.filter(x => x.status_node.id === dep.target)[0]);
                }
            }
        }

        if (!taskData.status_current.is_finish) {
            availableStatuses = availableStatuses.concat(this.board.status_node_settings_of_member.filter(x => x.status_node.is_universal));
        }

        if (taskData.status_current.is_universal) {
            availableStatuses = this.board.status_node_settings_of_member.filter(x => x.status_node.is_initial);
        }

        if (availableStatuses) {
            for (const status of availableStatuses) {
                const column = this.statusesWithTask.filter(x => x.id === status.status_node.id)[0];
                if (column) {
                    if (this.currentMember.project_setting.is_project_admin) {
                        column.canDrop = true;
                    } else {
                        if ((taskData.user_roles.includes('executor') ||
                                taskData.user_roles.includes('responsible') ||
                                taskData.author_guid === this.currentMember.guid) &&
                            !column.is_successful && !taskData.contract_guid &&
                            !taskData.status_current.is_finish
                        ) {
                            column.canDrop = true;
                        }
                    }
                }
            }
        }
    }

    getClass(task): string {
        switch (task.importance) {
            case 'NORMAL':
                return 'table-light';
            case 'MIDDLE':
                return 'table-warning';
            case 'IMPORTANT':
                return 'table-danger';
        }
    }
}
